import { useEffect, useMemo, useState } from "react";

import { cn, getText } from "shared/lib";

import { AnimatedText, GridLoader, Skeleton } from "shared/components";

import "./QuestionLoader.css";

export interface QuestionLoaderProps {
  className?: string;
}

export function QuestionLoader({ className }: QuestionLoaderProps) {
  const sentences = useMemo(() => [
    getText("🤓 Analysing your response"),
    getText("🔎 Checking the planning scheme"),
    getText("✍️ Crafting the next best question"),
  ], []);

  const [currentSentence, setCurrentSentence] = useState(sentences[0]);
  const [ellipsesAnimationCount, setEllipsesAnimationCount] = useState(0);

  useEffect(() => {
    if (ellipsesAnimationCount >= 3) {
      const currentIndex = sentences.indexOf(currentSentence);
      const nextIndex = (currentIndex + 1) % sentences.length;
      setCurrentSentence(sentences[nextIndex]);
      setEllipsesAnimationCount(0);
    }
  }, [ellipsesAnimationCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCompleteSentenceAnimation = () => {
    setEllipsesAnimationCount(1);
  };

  const handleCompleteEllipsesAnimation = () => {
    setEllipsesAnimationCount((prev) => prev + 1);
  };

  return (
    <div
      className={cn(
        "question-loader-transition flex flex-col gap-5",
        className,
      )}
    >
      <GridLoader />

      <h2 className="text-headinglg md:text-heading2xl text-textDisabled flex">
        {ellipsesAnimationCount === 0 ? (
          <>
            <span>{currentSentence.slice(0, 2)}&nbsp;</span>
            <AnimatedText
              onCompleteAnimation={handleCompleteSentenceAnimation}
              pauseAnimation={ellipsesAnimationCount > 0}
              text={currentSentence.slice(2)}
              textAnimationSpeed={60}
            />
          </>
        ) : null}
        {ellipsesAnimationCount > 0 ? (
          <>
            <div>{currentSentence}</div>
            <AnimatedText
              onCompleteAnimation={handleCompleteEllipsesAnimation}
              text="..."
            />
          </>
        ) : null}
      </h2>

      <div className="flex flex-col gap-3">
        <Skeleton className="bg-interfaceBorder h-[7px] w-full" />
        <Skeleton className="bg-interfaceBorder h-[7px] w-full" />
        <Skeleton className="bg-interfaceBorder h-[7px] w-[105px]" />
      </div>
    </div>
  );
}
